module.exports = __webpack_public_path__ + "img/banner02.570d270e.jpg";